import React, { Fragment } from 'react';
//import { withRouter } from 'react-router';
//import { compose } from 'redux';
//import { connect } from 'react-redux';
//import { userLogout } from '../../Actions';
import { Link } from 'react-router-dom';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button,
  NavLink,
  Badge,
  Tooltip,
} from 'reactstrap';
import MainMenu from '../Common/MainMenu';

export default class NavigationBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      tooltipOpen: false
    };
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  };
  toggleTooltip = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  };

  closeNavbar = () => {
    if (this.state.isOpen) {
      this.toggle();
    }
  };

  getCardsCount = () => {
    const { Items } = this.props.shoppingCart;
    let count = 0;
    Items.forEach(item => {
      count += item.Quantity;
    });
    return count;
  };

  render() {
    const { isOpen, currentUser, shoppingCart, userLogout } = this.props;
    const cartIsEmpty = !(
      shoppingCart &&
      shoppingCart.Items &&
      shoppingCart.Items.length > 0
    );

    return (
      <Navbar color="primary" dark expand="md" sticky="top">
        <NavbarToggler onClick={this.toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="mr-auto" navbar>
            <NavItem><MainMenu {...this.props} /></NavItem>
            <NavItem onClick={this.closeNavbar}>
              <Link to="/">
                <span className="nav-link">Home</span>
              </Link>
            </NavItem>
            <NavItem onClick={this.closeNavbar}>
              <Link to="/About">
                <span className="nav-link">About</span>
              </Link>
            </NavItem>
            <UncontrolledDropdown nav inNavbar className="d-none d-lg-block">
              <DropdownToggle nav caret>
                Purchase
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem href="/Purchase/PhysicalCards">
                  <span className="nav-link">Physical Cards</span>
                </DropdownItem>
                <DropdownItem href="/Purchase/eCards">
                  <span className="nav-link">Digital Cards</span>
                </DropdownItem>
                <DropdownItem href="/Purchase/CustomPhysicalCards">
                  <span className="nav-link" id="customPhysicalCardsHelp">
                    Custom Gift Cards{'  '}
                    <i className={`fa fa-info-circle`} />
                  </span>
                </DropdownItem>
                <DropdownItem href="/Purchase/PrintCards">
                  <span className="nav-link">Printable Cards</span>
                </DropdownItem>
                <DropdownItem href="/Purchase/HonorCards">
                  <span className="nav-link">Honor Cards</span>
                </DropdownItem>
                <DropdownItem href="/Purchase/RedemptionCodes">
                  <span className="nav-link">Redemption Codes</span>
                </DropdownItem>
                <DropdownItem href="/Purchase/DirectToCharityDonation">
                  <span className="nav-link">Direct Donation</span>
                </DropdownItem>
                <DropdownItem href="/GCE">
                  <span className="nav-link">Donate Retail Cards</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <NavItem>
              <NavLink tag={Link} to="/CorporateSolutions">
                Corporate
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="https://charitychoicegc.wixsite.com/charitychoice" target="__blank">
                Blog
              </NavLink>
            </NavItem>
          </Nav>
          <Nav className="ml-auto" navbar>
            {!cartIsEmpty && (
              <Fragment>
                <Link to="/Purchase/ShoppingCart">
                  <div className="nav-link d-flex">
                    <div className="nav-cart-container">
                      <i className={`fa fa-shopping-cart`} />
                      <Badge color="secondary" className="cart-badge">
                        {this.getCardsCount()}
                      </Badge>
                    </div>
                    <span>Cart</span>
                  </div>
                </Link>
                <a className="nav-link btn-link" href="/Purchase/ShoppingCart">
                  <i className={`fa fa-arrow-right`} /> <span>Check Out</span>
                </a>
              </Fragment>
            )}
            {currentUser ? (
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav>
                  <i className={`fa fa-user`} /> <span>Account</span>
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem href="/Login.aspx">
                    <i className="fas fa-cog text-primary" />
                    My Account
                  </DropdownItem>
                  <DropdownItem href="/MyOrders.aspx">
                    <i className="fas fa-cog text-primary" />
                    My Orders
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem onClick={this.closeNavbar}>
                    <NavLink onClick={userLogout}>
                      <i className="fas fa-sign-out-alt text-primary" />
                      Sign Out
                    </NavLink>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            ) : (
                <Button className="btn-login" color="link">
                  <a href="/Login.aspx">
                    <i className={`fa fa-user`} />
                    <span>Login</span>
                  </a>
                </Button>
              )}
            <Link to="/Contact" onClick={this.closeNavbar}>
              <span className="nav-link">Contact</span>
            </Link>
            <a
              className="nav-link"
              href="https://www.facebook.com/CharityChoice"
              target="_blank"
              rel="noopener noreferrer"
              title="CharityChoice on Facebook"
              onClick={this.closeNavbar}>
              <i className="fab fa-facebook" />
            </a>
            <a
              className="nav-link"
              href="https://twitter.com/CharityChoice"
              target="_blank"
              rel="noopener noreferrer"
              title="Follow us on Twitter"
              onClick={this.closeNavbar}>
              <i className="fab fa-twitter" />
            </a>
            <a
              className="nav-link"
              href="https://www.instagram.com/charity.choice_/"
              target="_blank"
              rel="noopener noreferrer"
              title="CharityChoice on Instagram"
              onClick={this.closeNavbar}>
              <i className="fab fa-instagram" />
            </a>
          </Nav>
        </Collapse>
        <Tooltip
          placement="right"
          isOpen={this.state.tooltipOpen}
          target="customPhysicalCardsHelp"
          trigger="click hover focus"
          toggle={this.toggleTooltip}>
          Corporate and Event Orders
          <br />
          (100 cards or more)
        </Tooltip>
      </Navbar>
    );
  }
}

/*
function mapStateToProps(state) {
  return {
    currentUser: state.authReducer.currentUser,
    shoppingCart: state.cartReducer.shoppingCart,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    userLogout: () => dispatch(userLogout()),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default compose(
  withRouter,
  withConnect
)(NavigationBar);
*/
